<template>
  <v-dialog
      v-model="dialog"
      max-width="900"
      style="overflow: hidden !important"
  >
    <v-card>
      <v-card-title>
        {{ processType == "new" ? "Slider Ekle" : "Slider Düzenle" }}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container">
          <div class="row">
              <img
                  :src="slider.image"
                  alt=""
                  style="width: 400px; height: auto"
                  @click="expandImage(slider.image)"
              />

            <div class="col-md-12 text-center">
              <label for="">Resim</label>
              <v-file-input
                  solo
                  filled
                  dense
                  accept="image/*"
                  placeholder="Dosya Seçin"
                  :value="selectedImage"
                  @change="sliderImageChange"
              ></v-file-input>
            </div>
            <div class="col-lg-12 text-center" v-if="this.sliderImagePreview">
              <h5>Önizleme</h5>
              <img
                  :src="addBase64Prefix(sliderImagePreview)"
                  alt=""
                  style="width: 400px; height: auto"
                  @click="expandImage(addBase64Prefix(sliderImagePreview))"
              />
              <p class="mt-3">UYARI: Seçmiş olduğunuz dosya var kaydet butonuna bastığınızda var olan dosya ile değişecektir. </p>
            </div>
            <div class="col-lg-12">
              <v-text-field
                  solo
                  filled
                  dense
                  v-model="slider.title"
                  label="Başlık"
                  :error-messages="validationMessages($v.slider.title, 'Başlık')"
                  prepend-inner-icon="mdi-page-layout-header"
                  @input="$v.slider.title.$touch()"
                  @blur="$v.slider.title.$touch()"
              ></v-text-field>
            </div>
            <div class="col-lg-12">
              <v-textarea
                  solo
                  filled
                  dense
                  v-model="slider.text"
                  label="Yazı"
                  :error-messages="validationMessages($v.slider.text, 'Yazı')"
                  prepend-inner-icon="mdi-format-indent-increase"
                  @input="$v.slider.text.$touch()"
                  @blur="$v.slider.text.$touch()"
              ></v-textarea>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  solo
                  filled
                  dense
                  v-model="slider.sequence"
                  label="Sıra"
                  type="number"
                  min="1"
                  :error-messages="
                  validationMessages($v.slider.sequence, 'Taksit')
                "
                  prepend-inner-icon="mdi-numeric"
                  @input="$v.slider.sequence.$touch()"
                  @blur="$v.slider.sequence.$touch()"
              ></v-text-field>
            </div>
            <div class="col-lg-6">
              <v-text-field
                  solo
                  filled
                  dense
                  v-model="slider.link"
                  label="URL"
                  prepend-inner-icon="mdi-web"
              ></v-text-field>
            </div>
            <div class="col-lg-6">
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      solo
                      filled
                      dense
                      :value="formattedDate(slider.startDate,'DD MMMM YYYY')"
                      label="Başlangıç Tarihi"
                      :error-messages="
                      validationMessages(
                        $v.slider.startDate,
                        'Başlangıç Tarihi'
                      )
                    "
                      prepend-inner-icon="mdi-calendar"
                      @input="$v.slider.startDate.$touch()"
                      @blur="$v.slider.startDate.$touch()"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    solo
                    filled
                    dense
                    v-model="slider.startDate"
                    locale="tr"
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="col-lg-6">
              <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      solo
                      filled
                      dense
                      :value="formattedDate(slider.finishDate,'DD MMMM YYYY')"
                      label="Bitiş Tarihi"
                      :error-messages="
                      validationMessages($v.slider.finishDate, 'Bitiş Tarihi')
                    "
                      prepend-inner-icon="mdi-calendar"
                      @input="$v.slider.finishDate.$touch()"
                      @blur="$v.slider.finishDate.$touch()"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    solo
                    filled
                    dense
                    v-model="slider.finishDate"
                    locale="tr"
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="col-lg-6">
              <label for="">Aktiflik Durumu</label>
              <v-switch
                  solo
                  filled
                  dense
                  v-model="slider.isActive"
                  :label="slider.isActive ? 'Aktif' : 'Pasif'"
              >
              </v-switch>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="closeDialog()">İptal</v-btn>
        <v-btn text color="success" @click="saveForm">Kaydet</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {validationMessages} from "@/validationMessages.js";
import {mapState, mapActions} from "vuex";
import {imageToBase64,addBase64Prefix} from "@/base64Helper";
import {formattedDate} from "@/momentHelper";
import axios from "axios";
import store from "@/state/store";
import {showProcessSuccessMessage} from "@/state/alertHelpers";
//import simplebar from "simplebar-vue";

export default {
  mixins: [validationMixin],

  validations() {
    //const self = this;
    return {
      slider: {
        title: {required},
        text: {required},
        sequence: {required},
        startDate: {required},
        finishDate: {required},
      },
    };
  },

  components: {
    //  simplebar
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    sliderProp: {
      type: Object,
      default: () => ({
        id: null,
        image: null,
        title: "",
        content: "",
        order: "",
        startDate: "",
        isActive: true,
      }),
    },
    processType: {
      type: String,
      default: "new",
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      selectedImage: null,
      dialog: false,
      showPassword: false,
      roleGroupList: ["Yönetici", "Plasiyer", "Müşteri"],
      slider: {
        image: null,
        title: "",
        content: "",
        order: "",
        startDate: "",
        isActive: true,
      },
      sliderImagePreview : null
    };
  },
  methods: {
    addBase64Prefix,
    imageToBase64,
    formattedDate,
    ...mapActions("slider", ["sliderAdd", "sliderUpdate","fetchSliderList"]),
    validationMessages,
    closeDialog() {
      this.dialog = false;
      this.$v.$reset();
    },
    createEmptyFile() {
  // Boş bir Blob oluşturun. İkinci parametre olarak dosyanın adını ve tipini belirleyebilirsiniz.
  const emptyFile = new File([""], "empty", { type: "text/plain" });

  return emptyFile;
},
    async saveForm() {
      const ipAdress = localStorage.getItem("ipAddress");
      const port = localStorage.getItem("port");
      this.$v.$touch();

      if (!this.$v.$invalid) {
        if (this.processType === "new") {
          const formData = new FormData();
          formData.append("post[Image]", this.selectedImage);
          formData.append("post[Title]",this.slider.title);
          formData.append("post[Text]",this.slider.text);
          formData.append("post[Sequence]",this.slider.sequence);
          formData.append("post[startDate]",this.slider.startDate);
          formData.append("post[finishDate]",this.slider.finishDate);
          formData.append("post[isActive]",this.slider.isActive);
          formData.append("post[Link]",this.slider.link);
          formData.append("method","POST");
          formData.append("url",`http://${ipAdress}:${port}/api/v1/slider/add?userId=${this.user.UserId}`);
          await axios.post(`https://${window.location.host}/api/redirect`,formData,{
            headers: {
              "Content-Type": "multipart/form-data",
              "Authorization": "Bearer " + store.state.auth.token
            },
          }).then((response) => {
            showProcessSuccessMessage({
              title:"İşlem Başarılı",
              text:response.data.message
            })
            this.fetchSliderList({
              params: {
                userId: this.user.UserId
              }
            });
          })
          // await this.sliderAdd({
          //   params: {
          //     userId: this.user.UserId,
          //   },
          //   body: formData,
          //   urlSegments: [],
          // });
        } else {
          const formData = new FormData();
          formData.append("post[Id]", this.slider.id);
          if (this.selectedImage) {
          formData.append("post[Image]", this.selectedImage);
          }
          formData.append("post[Title]",this.slider.title);
          formData.append("post[Text]",this.slider.text);
          formData.append("post[Sequence]",this.slider.sequence);
          formData.append("post[startDate]",this.slider.startDate);
          formData.append("post[finishDate]",this.slider.finishDate);
          formData.append("post[isActive]",this.slider.isActive);
          formData.append("post[Link]",this.slider.link);
          formData.append("method","POST");
          formData.append("url",`http://${ipAdress}:${port}/api/v1/slider/update?userId=${this.user.UserId}`);
          await axios.post(`https://${window.location.host}/api/redirect`,formData,{
            headers: {
              "Content-Type": "multipart/form-data",
              "Authorization": "Bearer " + store.state.auth.token
            },
          }).then((response) => {
            showProcessSuccessMessage({
              title:"İşlem Başarılı",
              text:response.data.message
            })
            this.fetchSliderList({
              params: {
                userId: this.user.UserId
              }
            });
          })

          // await this.sliderUpdate({
          //   params: {
          //     userId: this.user.UserId,
          //   },
          //   body: {
          //     id: this.slider.id,
          //     title: this.slider.title,
          //     text: this.slider.text,
          //     image: this.sliderImagePreview ? this.sliderImagePreview : this.slider.image,
          //     sequence: this.slider.sequence,
          //     startDate: this.slider.startDate,
          //     finishDate: this.slider.finishDate,
          //     isActive: this.slider.isActive,
          //     link: this.slider.link
          //   },
          //   urlSegments: [],
          // });
        }
        this.closeDialog();
      }
    },
    expandImage(images) {
      this.$viewerApi({
        images: [images],
      });
    },
    async sliderImageChange(file){
      if (file) {
        this.selectedImage = file;
        this.sliderImagePreview = await imageToBase64(file);
        this.slider.image = this.sliderImagePreview;
      }
      else
        this.sliderImagePreview = null;
    },
    },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
      if (this.processType === 'new') {
        this.slider = {
          image: null,
          title: "",
          content: "",
          order: "",
          startDate: null,
          finishDate: null,
          isActive: true,
        };
        this.sliderImagePreview= null;
        this.selectedImage=null;
      }
    },
    sliderProp: function (newVal) {
      if (newVal) {
        this.slider = Object.assign({}, newVal);
        this.slider.startDate = this.formattedDate(this.slider.startDate, "MM-DD-YYYY")
        this.slider.finishDate = this.formattedDate(this.slider.finishDate, "MM-DD-YYYY")
      } else{
        this.slider = {
          image: null,
          title: "",
          content: "",
          order: "",
          startDate: null,
          finishDate: null,
          isActive: true,
        };
      }
    },
  },
};
</script>